export enum AttachmentsLinks {
  GetContent = "getContent",
  GetPreview = "getPreview",
  Delete = "deleteAttachment",
  AddAnother = "addAttachmentOnSameTransaction",
}
